import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/home/index.vue')
  },{
    path: '/scene',
    name: 'Scene',
    component: () => import('../pages/sceneiframe/index.vue'),
    meta: {id: '2'}
  },
  {
    path: '/panorama',
    name: 'Panorama',
    component: () => import('../pages/panorama/index.vue'),
    meta: {id: 11}
  },{
    path: '/detail',
    name: 'Detail',
    component: () => import('../pages/detail/index.vue'),
    meta: {id: 15}
  } 
  /* ,
  {
    path: '/scenes',
    name: 'Scenes',
    component: () => import('../pages/scenes/index.vue'),
    meta: {id: '5'}
  },
  ,
  {
    path: '/antiques',
    name: 'Antiques',
    component: () => import('../pages/antiques/index.vue'),
    meta: {id: 10}
  },
  */
]

const router = new VueRouter({
  routes
})

export default router
